import MyJobs from '@/Component/Influencer/MyJobs'

const MyJobsPage = () => {
  return (
    <MyJobs />
  )
}

export default MyJobsPage
